import apiClient from "./ApiInterceptor";

export const forgotPassword = async (resetEmail) => {
    await apiClient.post("/auth/forgot-password", { email: resetEmail });
};

export const resetPassword = async (token, password) => {
    const response = await apiClient.post("/auth/reset-password", { token, password });
    return response;
};
